import { useTheme } from '@shopify/restyle';
import { loginAsPromptAtom } from 'app/atoms/app';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { Thumbnail } from 'app/design/primitives/thumbnail';

import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import type { Theme } from 'app/shopify';
import { IconArrowRight } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';

export function LoginAsPromptModal() {
  const { t } = useTranslation('loginAsPrompt');
  const theme = useTheme<Theme>();
  const [prompt, setPrompt] = useAtom(loginAsPromptAtom);

  const isVisible = prompt !== null;

  const handleConfirm = () => {
    prompt?.resolve(true);
    setPrompt(null);
  };

  const handleCancel = () => {
    prompt?.resolve(false);
    setPrompt(null);
  };

  return (
    <Modal animationType="slide" transparent open={isVisible} onClose={handleCancel} statusBarTranslucent>
      <Column
        backgroundColor="white"
        borderRadius="radius.lg"
        gap="spacing.general.x4"
        marginHorizontal="spacing.general.x4"
        paddingBottom="spacing.general.x10"
        paddingHorizontal="spacing.general.x4"
        paddingTop="spacing.general.x2"
      >
        <Column
          alignSelf="center"
          backgroundColor="surface.disabled"
          borderRadius="radius.sm"
          height={4}
          marginBottom="spacing.general.x2"
          width={40}
        />
        <Column gap="spacing.general.x4" paddingHorizontal="spacing.general.x6">
          <Row alignItems="center" justifyContent="center" gap="spacing.general.x4">
            <Thumbnail hideEditButton height={64} source={{ uri: prompt?.currentUserPicture }} />
            <IconArrowRight strokeWidth={ICON_STROKE_WIDTH} color={theme.colors['surface.default']} />
            <Thumbnail hideEditButton height={64} source={{ uri: prompt?.loginAsUserPicture }} />
          </Row>
          <Text fontWeight="700" textAlign="center" variant="headerXSmall">
            {t('title', { userName: prompt?.userName })}
          </Text>
          <Text textAlign="center">{t('message', { userName: prompt?.userName })}</Text>
          <Button height={50} onPress={handleConfirm} variant="signup">
            {t('yes')}
          </Button>
          <Button
            height={50}
            style={{ borderRadius: theme.borderRadii['radius.full'] }}
            onPress={handleCancel}
            testID="login-as-no-button"
            variant="secondary"
          >
            <Text flex={1} fontWeight="700" textAlign="center">
              {t('no')}
            </Text>
          </Button>
        </Column>
      </Column>
    </Modal>
  );
}
